import { render, staticRenderFns } from "./items-tooltip.vue?vue&type=template&id=2970fd37&scoped=true&"
import script from "./items-tooltip.vue?vue&type=script&lang=js&"
export * from "./items-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./items-tooltip.vue?vue&type=style&index=0&id=2970fd37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2970fd37",
  null
  
)

export default component.exports